/* import __COLOCATED_TEMPLATE__ from './base.hbs'; */
var _dec, _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
let TwoFactorRowBaseComponent = (_dec = service('ember-multipass-logging'), _class = class TwoFactorRowBaseComponent extends Component {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "logger", _descriptor2, this);
    _initializerDefineProperty(this, "optInButtonLoading", _descriptor3, this);
    this.logger.addComponentBreadcrumb('TwoFactorRowBaseComponent');
  }
  get detailDescription() {
    return this.args.detail.sms ? this.args.detail.description : this.intl.t(`${this.args.tPrefix}two_factor.row.authenticator_app`);
  }
  get detailClassname() {
    let selector = this.args.detail?.sms ? 'sms' : 'auth-app';
    if (this.args.bottomDivider) {
      selector += ' bottom-divider';
    }
    return selector;
  }
  get createdAt() {
    return new Date(this.args.detail.created_at).toLocaleDateString();
  }
  async onOptIn() {
    this.optInButtonLoading = true;
    await this.args.onOptIn();
    this.optInButtonLoading = false;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "logger", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "optInButtonLoading", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "onOptIn", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onOptIn"), _class.prototype), _class);
export { TwoFactorRowBaseComponent as default };